@import '../../styles/progress.css';
@import '../../styles/buttons.css';

:host {
  width: 100%;
  display: block;
  font-family: Helvetica, Arial, sans-serif;
  line-height: 1.2;
  font-weight: normal;
  text-align: left;
}


#dates-wrapper {
  position: relative;
}

.initial-loading,
.no-available-slots {
  width: 100%;
  min-height: 430px;
  background: #cccccc2c;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.unavailable-message {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 400px;
  color: #333;
  background-color: #f8f8f8;
  background-size: 9px 9px;
  background-image: repeating-linear-gradient(45deg, #dfdfdf 0, #dfdfdf 1px, #ffffffff 0, #ffffffff 50%);
}

.unavailable-message p {
  background: #fff;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.footer {
  display: flex;
  justify-content: end;
  font-size: 12px;
  align-content: center;
  flex-wrap: wrap;
  column-gap: 30px;
  padding: 15px 10px 0;
}

.footer .row {
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
}

.footer a {
  color: #666;
  margin: 5px 0;
  transition: opacity 0.2s ease;
}

.footer a:hover {
  opacity: 0.8;
}

.footer .logo-icon {
  width: 14px;
  vertical-align: middle;
  margin-right: 4px;
}